import * as i0 from '@angular/core';
import { Injectable, Optional, NgModule } from '@angular/core';
import { GenericModalComponent, GenericModalModule } from '@egovsolutions/angular-generic-modal';
import * as i1 from '@egovsolutions/angular-dialog-navigations';
import * as i2 from '@egovsolutions/angular-scrollable-modal';
import * as i3 from '@angular/material/dialog';

class QuickModal {
    constructor(
    // Dependencies
    dialogNavigations, scrollableModal, matDialog) {
        this.dialogNavigations = dialogNavigations;
        this.scrollableModal = scrollableModal;
        this.matDialog = matDialog;
    }
    show(content, navigate = true) {
        if (!this.scrollableModal && !this.matDialog)
            throw new Error('No modal provider for QuickModal service. Whenever possible provide ScrollableModal. Otherwise, provide MatDialog.');
        let dialogRef;
        if (this.scrollableModal)
            dialogRef = this.scrollableModal.open(GenericModalComponent, {
                data: content,
                autoFocus: false,
            });
        else
            dialogRef = this.matDialog.open(GenericModalComponent, {
                data: content,
                autoFocus: false,
            });
        if (navigate) {
            if (!this.dialogNavigations)
                console.warn('A call to QuickModal\'s .open() method was just made, with the navigate parameter set to true, but optional dependency DialogNavigations hasn\'t been provided.');
            else
                this.dialogNavigations.set(dialogRef);
        }
        return dialogRef;
    }
}
QuickModal.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: QuickModal, deps: [{ token: i1.DialogNavigations, optional: true }, { token: i2.ScrollableModal, optional: true }, { token: i3.MatDialog, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
QuickModal.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: QuickModal });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: QuickModal, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.DialogNavigations, decorators: [{
                    type: Optional
                }] }, { type: i2.ScrollableModal, decorators: [{
                    type: Optional
                }] }, { type: i3.MatDialog, decorators: [{
                    type: Optional
                }] }]; } });

class QuickModalModule {
}
QuickModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: QuickModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
QuickModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: QuickModalModule, imports: [GenericModalModule] });
QuickModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: QuickModalModule, providers: [
        QuickModal
    ], imports: [[
            GenericModalModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: QuickModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        GenericModalModule
                    ],
                    providers: [
                        QuickModal
                    ]
                }]
        }] });

/*
 * Public API Surface of angular-quick-modal
 */

/**
 * Generated bundle index. Do not edit.
 */

export { QuickModal, QuickModalModule };
